import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import Button from '../ui/Button';
import Footer from '../Footer';
import apiService from '../../services/ApiService';

const ResetPasswordPage: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  return (
    <PageShell>
      <div className="max-w-md mx-auto px-4 py-16">
        <h1 className="font-display text-3xl text-white font-semibold">Choose a new password</h1>
        <form
          className="mt-6 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            setError('');
            setMessage('');
            if (password !== confirm) {
              setError('Passwords do not match.');
              return;
            }
            setLoading(true);
            void apiService
              .resetPassword(token, password)
              .then((res: any) => {
                if (res.success) setMessage(res.message || 'Password updated.');
                else setError(res.error || 'Unable to reset password.');
              })
              .catch((err: any) => setError(err?.message || 'Unable to reset password.'))
              .finally(() => setLoading(false));
          }}
        >
          <label className="block">
            <span className="input-label">New password</span>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="new-password"
              minLength={8}
            />
          </label>
          <label className="block">
            <span className="input-label">Confirm password</span>
            <input
              type="password"
              className="input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              autoComplete="new-password"
              minLength={8}
            />
          </label>
          {error ? (
            <p className="text-sm text-red-300" role="alert">
              {error}
            </p>
          ) : null}
          {message ? (
            <p className="text-sm text-emerald-300" role="status">
              {message}
            </p>
          ) : null}
          <Button type="submit" variant="primary" loading={loading} className="w-full min-h-[44px]" disabled={!token}>
            Update password
          </Button>
        </form>
        <p className="mt-6 text-sm text-gray-500">
          <Link to="/login" className="text-orange-300 hover:text-orange-200">
            Sign in
          </Link>
        </p>
      </div>
      <Footer />
    </PageShell>
  );
};

export default ResetPasswordPage;
